import React, { Component } from 'react'
import { Container, Row, Col, Navbar, Nav, Button } from 'react-bootstrap'
import { Link } from "react-router-dom";
import BrandLogo from '../navbars/BrandLogo';

class NavbarTop extends Component {
  render() {
    return (
      <div className="student-login-register">
        <Container>
          <Navbar expand="lg" >
            <Navbar.Brand href="https://rizee.in">
              <BrandLogo fill="#ffffff" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="top-navbar ml-auto">
                <Nav.Link href="https://rizee.in">Home</Nav.Link>
                <Nav.Link href="https://rizee.in/#services"> Features</Nav.Link>
                <Nav.Link href="https://rizee.in/support">Support</Nav.Link>
                <Nav.Link href="https://rizee.in/blog">Blog</Nav.Link>
                <Nav.Link href="https://rizee.in/Registration/?src=website">Registration</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <Row>
            <Col xl={{ span: 8, offset: 2 }} lg={{ span: 8, offset: 2 }} md={12} className="title-sections">
              <h2 className="heading text-white titilliumweb_font">Welcome to Rizee</h2>
              <p className="sub-title text-white titilliumweb_font">The Best competitive exam preparation
<br/>platform in the world</p>
            </Col>
          </Row>
        </Container>
        <svg className="LayerCurve" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 250">
          <path id="Shape 1" fill="#ffffff" d="M0 219C0 219 1974 16.22 2048 0L2048 250L0 250L0 219Z" />
        </svg>
      </div>
    )
  }
}

export default NavbarTop

